import React from 'react'

export const Banner = () => {
  return (
    <>

<section class="pt-10 overflow-hidden bg-[#D9F8FF] md:pt-0 sm:pt-16 2xl:pt-16 ">
    <div class="px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl">
        <div class="grid items-center grid-cols-1 md:grid-cols-2">
            <div>
                <h2 class="text-3xl font-bold leading-tight text-black sm:text-4xl lg:text-5xl web-font">Hello and <br class="block sm:hidden" />Welcome</h2>
                <p class="max-w-lg mt-3 text-3xl leading-relaxed text-black md:mt-8 web-font2">Greeting from Shopworks ,  which is online protal community to digitalize stores and fostering a healthy envionment .</p>

                
            </div>

            <div class="relative">
      

                <img class="relative w-full xl:max-w-lg xl:mx-auto 2xl:origin-bottom 2xl:scale-110" src="/images/color Hex.png" alt="" />
            </div>
        </div>
    </div>
</section>

</>


  )
}
